import { Component } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { Appliances } from '@library/utils/constants/appliances';
import { ControlPageFooterAppliancesService } from '../control-page-footer-appliances.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-control-page-appliances-group-expanded',
  templateUrl: './control-page-appliances-group-expanded.component.html',
  styleUrls: ['./control-page-appliances-group-expanded.component.scss']
})
export class ControlPageAppliancesGroupExpandedComponent {

  Appliances = Appliances;

  EnumMeasureTypes = EnumMeasureTypes;

  vm$ = combineLatest({
    group: this.selectedAppliancesGroup.selectedGroup$,
    measureType: this.selectedAppliancesGroup.measureType$,
  });

  constructor(
    private selectedAppliancesGroup: ControlPageFooterAppliancesService,
  ) { }

  close() {
    this.selectedAppliancesGroup.selectedGroup.next(null);
  }

}
